import {useDispatch, useSelector} from 'react-redux'
import Overview from '../../assets/icons/Overview'
import {Badge, Box, Button, IconButton, Paper, Stack, Tooltip} from '@mui/material'
import commonActions from '../../actions/common.actions'
import {memo, useCallback, useEffect, useMemo, useState} from 'react'
import {subscriptionTags} from '../../assets/constants'
import {useLocation} from 'react-router-dom'
import Holdings from '../../assets/icons/Holdings';
import  HoldingsWidget  from '../holdings/HoldingsWidget';
import websocketActions from '../../actions/websocket.actions'
import Trade from '../../assets/icons/Trade'
import NewsIcon from '../../assets/icons/NewsIcon'
import Watchlists from '../watchlist/Watchlist'
import SecurityOverview from '../securityInfo/SecurityOverview'
import {WidgetListItems} from '../../util/sidebar'
import Positions from '../../assets/icons/Positions'
import PositionsWidget from '../postionsWidget'
import OrdersWidget from '../ordersWidget'
import {getNoOfOpenOrders, getNoOfPositions} from '../../selectors/orders'
import useSelectView from '../../hooks/useSelectView'
import Watchlist from '../../assets/icons/watchlist'
import AlarmIcon from '../../assets/icons/AlarmIcon'
import {NonInteractiveTooltip} from '../custom'
import {HelpCenter} from '../help/HelpCenter'
import FiiDiiOverview from '../fii_chart_overview/components/FiiDiiOverview'
import MarketNews from '../news/MarketNews'
import {setSteps} from '../../reducer/tour.reducer'
import ROUTES from '../../assets/routes'
import {matchRoute} from '../../util/routes'
import pathStepsMap from '../tour/tourStepsMap'
import AlertsSidebar from '../alerts/alertsSidebar/AlertsSidebar'
import {Calendars} from '../calendars/Calendars'
import GlobalNotification from '../GlobalNotification/GlobalNotification'
import GlobalNotificationIcon from '../../assets/icons/GlobalNotificationIcon'
import {selectGlobalNotifications} from '../../selectors/globalNotification'
import {selectRightSidebarWidget} from '../../selectors/common'
import ToursTipsIcon from "../../assets/icons/ToursTipsIcon";
import QuickWidgetsMenu from '../quickWidgetsMenu/quickWidgetsMenu'
import { selectStrategyBuilderMode } from '../../selectors/strategyBuilder'
import TradeWidget from '../TradePanel/tradeWidget'

const buttons = [
    {
        element: <Overview/>,
        label: 'Overview',
        code: WidgetListItems.OVERVIEW
    },
    {
        element: <Watchlist/>,
        label: 'Watchlist',
        code: WidgetListItems.WATCHLIST
    },
    {
        element: <AlarmIcon/>,
        label: 'Alert',
        code: WidgetListItems.ALERT
    },
    {
        element: <NewsIcon/>,
        label: 'News',
        code: WidgetListItems.MARKET_NEWS
    },
    {
        element: <Trade style={{fontSize: "40px"}}/>,
        label: 'Trade',
        code: WidgetListItems.TRADE
    },
    {
        element: <Positions/>,
        label: 'Positions/Orders',
        code: WidgetListItems.POSITIONS
    },
    // {
    //     element: <OrderIcon color="inherit" style={{fontSize: '40px'}}/>,
    //     label: 'Orders',
    //     code: WidgetListItems.ORDERS
    // },
    {
        element: <Holdings/>,
        label: 'Holdings',
        code: WidgetListItems.HOLDINGS
    }

]

const SideBarRight = ({blur}) => {
    const dispatch = useDispatch()
    const view = useSelector(selectRightSidebarWidget)
    const [rightSideWidgetView, setRightSideWidgetView] = useState<string | null>(view)
    const strategyBuilderMode = useSelector(selectStrategyBuilderMode);
    const homeView = useSelectView()
    const location = useLocation()
    
    const noOfOpenPositions = useSelector(getNoOfPositions)
    const noOfOpenOrders = useSelector(getNoOfOpenOrders)
    const notifications = useSelector(selectGlobalNotifications)

    const tourSteps = useMemo(() => {
        const routes = [
            {path: ROUTES.chart, key: 'chart'},
            {path: ROUTES.optionChain, key: 'option-chain'},
            {path: ROUTES.openInterest, key: 'multi-strike-chart'},
            {path: ROUTES.screener, key: 'screener'},
            {path: ROUTES.fiiDii, key: 'fii-dii'},
            {path: ROUTES.strategyBuilder, key: 'strategy-builder'}
        ]
        const matchedRoute = matchRoute(location.pathname, routes)
        if (matchedRoute && pathStepsMap[matchedRoute]) {
            return pathStepsMap[matchedRoute]
        }
        return []
    }, [location, pathStepsMap])

    const handleRightSideWidgetIconClick = useCallback((btnCode: WidgetListItems | null) => {
        const prevValue = rightSideWidgetView
        if (rightSideWidgetView === btnCode) {
            setRightSideWidgetView(null)
            commonActions.dispatchRightSideWidget(dispatch, null)
        } else {
            setRightSideWidgetView(btnCode)
            commonActions.dispatchRightSideWidget(dispatch, btnCode)
        }
        if (prevValue === WidgetListItems.OVERVIEW) {
            websocketActions.setWebsocketSubscribeList(dispatch, {
                securitySnapshotSubscriptions: [
                    {
                        tag: subscriptionTags.INDEX_COMPONENT,
                        securities: []
                    }
                ]
            })
        }
        if (prevValue === WidgetListItems.WATCHLIST) {
            websocketActions.setWebsocketSubscribeList(dispatch, {
                securitySnapshotSubscriptions: [
                    {
                        tag: subscriptionTags.WATCHLIST,
                        securities: []
                    }
                ]
            })
        }
    }, [dispatch, rightSideWidgetView])

    useEffect(() => {
        setRightSideWidgetView(view)
    }, [view])

    const renderRightSideWidget = useCallback((rightSideWidgetView: string) => {
        switch (rightSideWidgetView) {
            case WidgetListItems.WATCHLIST:
                return <Watchlists/>
            case WidgetListItems.OVERVIEW:
                return <SecurityOverview/>
            case WidgetListItems.ALERT:
                return <AlertsSidebar/>
            case WidgetListItems.MARKET_NEWS:
                return <MarketNews/>
            case WidgetListItems.POSITIONS:
                return <PositionsWidget/>
            case WidgetListItems.TRADE:
                return <TradeWidget/>
            case WidgetListItems.ORDERS:
                return <OrdersWidget/>
            case WidgetListItems.HOLDINGS:
                return <HoldingsWidget />;
            case WidgetListItems.NOTIFICATION:
                return <GlobalNotification/>
            default:
                return null
        }
    }, [location])

    const onProTipClicked = useCallback(() => {
        dispatch(setSteps(tourSteps))
    }, [tourSteps])

    return (
        <>
            {
                !!rightSideWidgetView ?
                    <div
                        className="widgetbar-pages"
                        style={{gridArea: 'widgetbar-pages', ...(blur ? { filter: 'blur(4px)', pointerEvents: 'none' } : {}) }}
                    >
                        {renderRightSideWidget(rightSideWidgetView)}
                    </div> : null
            }
            <Paper
                sx={{
                    gridArea: 'right-sidebar',
                    zIndex: 999,
                    borderRadius: '4px 4px 0 4px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    overflowY: 'auto',
                    marginLeft: 'var(--extra-small-spacing)'
                }}
                style={{ ...(blur ? { filter: 'blur(4px)', pointerEvents: 'none' } : {}) }}
            >
                <Box id="side-bar-right-options"
                     sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    {
                        buttons.map(
                            (btn, i) =>
                                <NonInteractiveTooltip arrow key={i} placement={'left'} title={btn.label}>
                                    <Button sx={{
                                        borderRadius: 0,
                                        maxHeight: 'screen',
                                        minWidth: 'max-content',
                                        display: 'inline-flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        '&:hover': {
                                            backgroundColor: (theme) => (rightSideWidgetView === btn.code) ? theme.palette.background.default : null
                                        },
                                        backgroundColor: (theme) => (rightSideWidgetView === btn.code) ?
                                            theme.palette.background.default : null
                                    }}
                                        color={'inherit'}
                                        onClick={() => handleRightSideWidgetIconClick(btn.code as any)}
                                        key={i}
                                        data-event={`${btn.label} Icon Clicked`}
                                        data-event-action={rightSideWidgetView === btn.code ? 'Closed' : 'Opened'}
                                    >
                                        <Badge
                                            color="primary"
                                            sx={{
                                                display: 'inline-flex',
                                                flexDirection: 'column',
                                                alignItems: 'center'
                                            }}
                                            badgeContent={
                                                WidgetListItems.POSITIONS === btn.code ? noOfOpenPositions :
                                                    WidgetListItems.ORDERS === btn.code ? noOfOpenOrders : 0
                                            }
                                            overlap="circular"
                                        >
                                            {btn.element}
                                            {/*<Typography style={{ paddingBottom: '8px' }} variant="body2">*/}
                                            {/*    {btn.code}*/}
                                            {/*</Typography>*/}
                                        </Badge>
                                    </Button>
                                </NonInteractiveTooltip>
                        )
                    }

                </Box>
                <Stack gap={1} alignItems={'center'} sx={{width: '100%'}}>
                    <QuickWidgetsMenu />
                    <Tooltip arrow placement="left" title={'Notification'}>
                        <IconButton onClick={() => handleRightSideWidgetIconClick(WidgetListItems.NOTIFICATION)}
                            data-event="Notifications Icon Clicked"
                            data-event-action={rightSideWidgetView === WidgetListItems.NOTIFICATION ? 'Closed' : 'Opened'}>
                            <Badge badgeContent={notifications.length} color="primary" overlap="circular">
                                <GlobalNotificationIcon/>
                            </Badge>
                        </IconButton>
                    </Tooltip>
                    {tourSteps.length > 0 ?
                        <IconButton data-event={'Pro Tip Clicked'} id={'show-tour-button'} onClick={onProTipClicked}>
                            <ToursTipsIcon/>
                        </IconButton>
                        : null
                    }
                    <Calendars/>
                    <HelpCenter/>
                </Stack>
            </Paper>
        </>
    )
}

export default memo(SideBarRight)